"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Options = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_popper_1 = require("react-popper");
const Styled = __importStar(require("./Dropdown.styles"));
const offsetModifier = { name: 'offset', options: { offset: [0, 8] } };
const widthModifier = {
    enabled: true,
    name: 'matchRefWidth',
    phase: 'beforeWrite',
    requires: ['computeStyles'],
    fn: ({ state }) => {
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state }) => {
        state.elements.popper.style.width = `${state.elements.reference.offsetWidth}px`;
    },
};
const Options = ({ onClickOption, selectRef, popperRef, setPopperRef, managerRef, placement, size, groups, options, }) => {
    const modifiers = [offsetModifier, widthModifier];
    const { styles, attributes } = (0, react_popper_1.usePopper)(selectRef, popperRef, { modifiers, placement });
    const renderOption = (option) => ((0, jsx_runtime_1.jsxs)(Styled.Option, Object.assign({ onClick: onClickOption(option), size: size }, option.attrs, { children: [!!option.icon && ((0, jsx_runtime_1.jsx)(Styled.IconWrapper, { children: (0, jsx_runtime_1.jsx)(option.icon, {}) })), (0, jsx_runtime_1.jsx)("span", { children: option.children || option.label || option.value })] }), option.value));
    const renderDisabledOption = (option) => ((0, jsx_runtime_1.jsxs)(Styled.DisabledOption, { onClick: onClickOption(option), size: size, children: [!!option.icon && ((0, jsx_runtime_1.jsx)(Styled.DisabledIconWrapper, { children: (0, jsx_runtime_1.jsx)(option.icon, {}) })), (0, jsx_runtime_1.jsx)("span", { children: option.children || option.label || option.value })] }, option.value));
    const renderSingleOption = (option) => option.isDisabled ? renderDisabledOption(option) : renderOption(option);
    const renderGroup = (group) => ((0, jsx_runtime_1.jsxs)(react_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Styled.OptionGroupWrapper, { children: (0, jsx_runtime_1.jsx)(Styled.OptionGroupName, { children: group.name }) }), group.options.map(renderSingleOption)] }, group.index));
    return ((0, jsx_runtime_1.jsx)(Styled.OptionsWrapper, Object.assign({}, attributes.popper, { placement,
        ref: (ref) => {
            setPopperRef(ref);
            managerRef.current = ref;
        },
        style: styles.popper, children: typeof groups === 'undefined' ? options && options.map(renderSingleOption) : groups.map(renderGroup) })));
};
exports.Options = Options;
